import { z } from 'zod';

import { NotificationCategorySchema } from '../notification-category/notification-category';
import { PreferenceChannelSchema } from '../notification-channel/notification-channel';

/**
 * A member changing one switch, or several.
 *
 * **A list of explicit changes, not a whole preferences object.** The screen is
 * a grid of switches a member flips one at a time, and sending the whole map
 * back would mean a member on a stale screen — one opened before a later phase
 * added a category — silently rewriting the categories they never saw. A patch
 * of named switches cannot do that.
 *
 * At least one change, because an empty request is a client bug rather than a
 * no-op worth answering 200 to.
 */
export const NotificationPreferenceChangeSchema = z
  .object({
    category: NotificationCategorySchema,
    /** A PREFERENCE channel: a member cannot switch a channel that is never a choice. */
    channel: PreferenceChannelSchema,
    enabled: z.boolean(),
  })
  .strict();

export type NotificationPreferenceChange = z.infer<typeof NotificationPreferenceChangeSchema>;

export const NotificationPreferencesUpdateSchema = z
  .object({ changes: z.array(NotificationPreferenceChangeSchema).min(1).max(64) })
  .strict();

export type NotificationPreferencesUpdateRequest = z.infer<
  typeof NotificationPreferencesUpdateSchema
>;
